import React from 'react'
import { BookingButton } from './'
import { isBooked, getString } from '../../../helpers/Functions'

const bookingColumn = (
  language,
  laundry,
  myBookings,
  otherBookings,
  timeId,
  date,
  bookingPressed
) => {
  const { id, functioning } = laundry
  let className = 'primary'
  let status = getString('book', language)
  if (!functioning) {
    className = 'warning'
    status = getString('outOfOrder', language)
  } else if (isBooked(myBookings, timeId, id, date)) {
    className = 'success'
    status = getString('unbook', language)
  } else if (isBooked(otherBookings, timeId, id, date)) {
    className = 'warning'
    status = getString('busy', language)
  }
  return (
    <BookingButton
      header={status}
      className={className}
      onClick={() => bookingPressed(timeId, id, date)}
    />
  )
}

const BookingRow = ({
  laundries = [],
  time = '',
  myBookings,
  otherBookings,
  language,
  timeId,
  date,
  bookingPressed
}) => {
  const { containerStyle, headerStyle } = styles
  let laundryArray = []
  laundries.forEach(laundry => {
    laundryArray = [
      ...laundryArray,
      bookingColumn(
        language,
        laundry,
        myBookings,
        otherBookings,
        timeId,
        date,
        bookingPressed
      )
    ]
  })
  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <p>{time}</p>
      </div>
      {laundryArray}
    </div>
  )
}

const styles = {
  containerStyle: {
    height: 64,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row'
  },
  headerStyle: {
    minWidth: 200,
    height: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}

export { BookingRow }



// WEBPACK FOOTER //
// ./src/components/common/bookingSchemeComponents/BookingRow.js